import { Colors } from '@lightningjs/sdk';
import CheckmarkButton, {
  CheckmarkButtonTemplateSpec,
} from './buttons/CheckmarkButton';
import { getImageTextureObj } from 'support/generalUtils';

export const SELECTED_ICON_EMPTY = getImageTextureObj(
  'static/images/checkmark-square-empty.svg',
  24,
  24,
);
export const SELECTED_ICON_FILLED = getImageTextureObj(
  'static/images/checkmark-square-filled.svg',
  24,
  24,
);

const HEIGHT = 37;
const MARGIN = 8;
const PADDING_H = 0;
const BORDER_RADIUS = 4;
const BORDER_STROKE = 4;

const CONTENT_MARGINS = { marginLeft: 8, marginRight: 0 };

export default class CheckmarkBullet extends CheckmarkButton {
  override get isSelected() {
    return this._isSelected;
  }

  override set isSelected(
    isSelected: CheckmarkButtonTemplateSpec['isSelected'],
  ) {
    this._isSelected = isSelected;

    this.setStartIcon(isSelected ? SELECTED_ICON_FILLED : SELECTED_ICON_EMPTY);
    this._StartIcon.patch({ shader: null });
  }

  override _setup() {
    super._setup();
    this.h = HEIGHT;
    this.margin = MARGIN;
    this.paddingH = PADDING_H;
    this.backgroundColor = {
      focused: Colors('transparent').get(),
      unfocused: Colors('transparent').get(),
    };

    this.patch({
      flex: {
        direction: 'row',
        justifyContent: 'flex-start',
      },
      shader: {
        radius: BORDER_RADIUS,
        stroke: BORDER_STROKE,
        strokeColor: Colors('transparent').get(),
      },
    });

    // Need to reset shaders because parents shaders get applied
    this._Label.patch({
      y: 2,
      flexItem: CONTENT_MARGINS,
      shader: null,
    });
    this._StartIcon.patch({
      flexItem: CONTENT_MARGINS,
      shader: null,
    });
  }

  override _focus() {
    this.patch({
      shader: {
        strokeColor: Colors('focusRed').get(),
      },
    });
  }

  override _unfocus() {
    this.patch({
      shader: {
        strokeColor: Colors('transparent').get(),
      },
    });
  }
}
